import React, { useState } from 'react';
import { Icon } from '../icons';

// Schermata "Password dimenticata": l'utente inserisce username o email e riceve
// (se l'account esiste ed ha un'email) un link di reset. La risposta del server
// e' volutamente generica per non rivelare quali account esistono.
function ForgotPassword({ onBack }) {
  const [identifier, setIdentifier] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    if (!identifier.trim()) { setError('Inserisci username o email'); return; }
    setLoading(true);
    try {
      const res = await fetch('/api/auth/forgot-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ identifier: identifier.trim() }),
      });
      const data = await res.json();
      if (!res.ok) { setError(data.error || 'Errore'); return; }
      setSent(true);
    } catch {
      setError('Impossibile contattare il server');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-wrap">
      <div className="login-hero">
        <div className="login-hero-top">
          <div className="login-logo"><Icon name="key" size={22} strokeWidth={2} /></div>
          <div className="login-brand-text" style={{ color: '#fff' }}>
            <strong style={{ display: 'block' }}>HIPLAAS</strong>
            <span>Manager</span>
          </div>
        </div>
        <div className="login-hero-mid">
          <h2>Recupera l'accesso al tuo account.</h2>
          <p>Ti invieremo un link per reimpostare la password all'indirizzo email associato al tuo account.</p>
        </div>
        <div className="login-hero-list">
          <div><span className="login-hero-icon"><Icon name="clock" size={16} /></span>Il link scade dopo 60 minuti</div>
          <div><span className="login-hero-icon"><Icon name="shield" size={16} /></span>Utilizzabile una sola volta</div>
        </div>
      </div>

      <div className="login-panel">
        <form className="login-card" onSubmit={submit}>
          <h1>Password dimenticata</h1>
          <p className="subtitle">Inserisci il tuo username o la tua email</p>

          {sent ? (
            <>
              <div className="msg msg-success" style={{ marginBottom: '1rem' }}>
                <Icon name="check" size={16} />
                Se l'account esiste ed ha un'email associata, riceverai a breve un link per reimpostare la password. Controlla anche lo spam.
              </div>
              <button type="button" className="btn btn-primary btn-block" onClick={onBack}>
                Torna al login
              </button>
            </>
          ) : (
            <>
              {error && <div className="msg msg-error" style={{ marginBottom: '1rem' }}><Icon name="alert" size={16} />{error}</div>}

              <div className="field">
                <label htmlFor="identifier">Username o email</label>
                <input id="identifier" className="input" type="text" value={identifier} onChange={(e) => setIdentifier(e.target.value)} placeholder="es. mario.rossi oppure mario@azienda.it" autoComplete="username" required autoFocus />
              </div>

              <button type="submit" className="btn btn-primary btn-block" disabled={loading} style={{ marginTop: '0.5rem' }}>
                {loading ? 'Invio in corso…' : 'Invia link di reset'}
              </button>
              <button type="button" className="btn btn-ghost btn-block" onClick={onBack} style={{ marginTop: '0.6rem' }}>
                Torna al login
              </button>
            </>
          )}
        </form>
      </div>
    </div>
  );
}

export default ForgotPassword;
